export function SelectInput({
  label,
  options,
  onChange,
  placeholder = null,
  defaultValue = '',
  ...inputProps
}) {
  function handleChange({ target }) {
    onChange(target.value);
  }

  return (
    <label className="root">
      <span className="label">{label}</span>
      <select
        className="select"
        onChange={handleChange}
        defaultValue={defaultValue}
        {...inputProps}
      >
        {placeholder && (
          <option value="" disabled>
            {placeholder}
          </option>
        )}
        {options.map(({ value, label }) => (
          <option key={value} value={value}>
            {label}
          </option>
        ))}
      </select>
      <style jsx>{`
        .root {
          display: block;
          margin-bottom: 18px;
        }

        .label {
          margin-bottom: 9px;
          display: block;
          font-weight: 600;
          color: var(--bgBlueish__text);
        }

        .select {
          width: 100%;
          box-sizing: border-box;
          height: 50px;
          padding: 0 12px;
          background-color: var(--bgBlueish);
          border: 3px solid var(--bgBlueish__fadedText);
          border-radius: 4px;
          font-size: 16px;
          font-weight: 500;
          line-height: normal;
          color: var(--bgBlueish__text);
        }

        .select:focus {
          outline: none;
          border-color: var(--bgBlueish__tintedText);
        }
      `}</style>
    </label>
  );
}
